import { CloseYearPickerButton } from './CloseYearPickerButton';
import { NextMonthButton } from './NextMonthButton';
import { PreviousMonthButton } from './PreviousMonthButton';
import { YearPickerToggleButton } from './YearPickerToggleButton';
import { HeaderContainer } from '../../styled';
export function Header() {
    return (<HeaderContainer>
      <PreviousMonthButton />
      <YearPickerToggleButton />
      <NextMonthButton />
      <CloseYearPickerButton />
    </HeaderContainer>);
}
